import { IconSearch } from '@tabler/icons-react'

import { AstraSideNavItem, KeyboardShortcutPreview } from '~/astra'
import { useCommandPalette } from '~/components/CommandPalette/CommandPaletteContext'
import { COMMAND_PALETTE_SHORTCUT } from '~/components/CommandPalette/DefaultCommandPalette'
import { useFlag } from '~/hooks/useFlag'
import { trackUserEvent } from '~/utils/analytics'

export const CommandPaletteButton = () => {
    const isCommandPaletteEnabled = useFlag('command_palette')
    const { open } = useCommandPalette()

    if (!isCommandPaletteEnabled) {
        return null
    }

    const handleOnClick = () => {
        open()
        void trackUserEvent('COMMAND_PALETTE_OPENED', { action: 'menuItem' })
    }

    return (
        <AstraSideNavItem
            icon={IconSearch}
            label="Søk"
            rightSlotClassName="flex gap-1"
            type="action"
            onClick={handleOnClick}
            rightSlot={<KeyboardShortcutPreview shortcut={COMMAND_PALETTE_SHORTCUT} />}
        />
    )
}
